export default __webpack_public_path__ + "static/media/sofa-ijo.363748d1.png";